import ManageTierContainer from './ManageTier.container';
import ManageTier from './ManageTier';
export default ManageTierContainer(ManageTier);
//# sourceMappingURL=index.js.map